import { AfterViewInit } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { ManageCodesService } from 'src/app/service/managecodes.service';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';
import { Buttons } from 'src/app/home/table/Buttons';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { ExcelHeadersService } from 'src/app/service/excelheaders.service';
import { Modal } from "bootstrap";

@Component({
  selector: 'app-search-users',
  templateUrl: './search-users.component.html',
  styleUrls: ['./search-users.component.css']
})
export class SearchUsersComponent implements OnInit {
  checked: boolean = false;
  getAsOfDateData: AddUser[] = [];
  filteredUserData: AddUser[] = [];
  selectedUser: AddUser[] = [];
  exportExcelUserData: AddUser[] = [];
  userData: AddUser[] = [];
  userModel = new AddUser();
  selectedUserModel = new AddUser();
  userModel1 = new AddUser();
  isShowActiveStatus: boolean = true;
  isShowInactiveStatus: boolean = false;
  ordersTableColumns: TableColumn[];
  buttons: Buttons[];
  supervisorNamesSet = new Set<string>();
  checkedactive: boolean = false;
  checkedinactive: boolean = false;
  isChecked: boolean = false;
  id: string = '';
  returnTo: string = '';
  hide: boolean = false;
  headder: string = 'Search Results';
  activeUserNotice = false;
  activeUserNoticeMessage = '';
  activeUserPersonId = '';
  activeUserDisplayName = '';
  activeUserCompasId = '';
  activeUserMatches: AddUser[] = [];
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = '';
  columnsData: any;
  dataForExcel = [];
  headersForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];

  public curDate: any;
  public prevDateOne: any;
  public prevDateTwo: any;

  comPlansUserData: AddUser[] = [];
  allComPlansUserData: AddUser[] = [];
  salesChnlsUserData: AddUser[] = [];
  salesChannels: string[] = [];
  commPlansData: string[] = [];
  userTypes: string[] = [];
  commPlans: string[] = [];
  salesRepTypes: string[] = [];
  payrollCalender: string[] = [];
  selectedTermDate: Date = null;
  selectedTermDateInput = '';
  termModalTitle = 'Terminate User';
  resolvedAsOfDateKey: string = '';
  resolvedAsOfDateLabel: string = '';

  /** Search-results Bulk Update modal */
  bulkFormModel = new AddUser();
  bulkFilteredComPlans: AddUser[] = [];
  bulkSupervisorData: AddUser[] = [];
  bulkControlSup = new FormControl();
  bulkFilteredSupValues: Observable<AddUser[]> | undefined;
  bulkSaving = false;
  bulkModalTitle = 'Bulk Update Users';
  bulkSalesChannelDisplay = '';

  @ViewChild("modal") modalElement: ElementRef;
  private modelInstance: Modal;

  @ViewChild("termmodal") termModalElement: ElementRef;
  private termModelInstance: Modal;

  @ViewChild("bulkupdatemodal") bulkUpdateModalElement: ElementRef;
  private bulkUpdateModalInstance: Modal;

  ngAfterViewInit() {
    this.modelInstance = new Modal(this.modalElement.nativeElement);
    this.termModelInstance = new Modal(this.termModalElement.nativeElement);
    if (this.bulkUpdateModalElement?.nativeElement) {
      this.bulkUpdateModalInstance = new Modal(this.bulkUpdateModalElement.nativeElement, {
        backdrop: 'static',
        keyboard: false
      });
    }
  }

  constructor(private router: Router,
    private manageUserService: ManageUserService,
    private manageCodesService: ManageCodesService,
    private approvalFlowService: ApprovalFlowService,
    private logger: LoggerService,
    private authGaurdService: AuthGaurdService,
    private route: ActivatedRoute, public exportExcelService: ExportExcelService,
    private httpService: HttpClient, private notificationService: NotificationService, private excelHeadersService: ExcelHeadersService) { }

  public displayedColumns = ['id', 'first_name', 'last_name', 'middle_name', 'email_address', 'user_type', 'sales_rep_id', 'commission_plan', 'assc_corps', 'sales_rep_channel', 'employeeId', 'current_rec_flag', 'soft_termination_date', 'operator_id', 'sales_rep_type'];
  public dataSource = new MatTableDataSource<AddUser>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  ngOnInit(): void {
    this.userModel = this.manageUserService.userModel;
    this.route.queryParams.subscribe(params => {
      this.id = params['page'];
      this.returnTo = params['returnTo'] || '';
      const returnFrom = params['returnFrom'];
      this.fileName = this.headder;
      this.activeUserNotice = false;
      this.activeUserNoticeMessage = '';
      this.activeUserPersonId = '';
      this.activeUserDisplayName = '';
      this.activeUserCompasId = '';
      this.activeUserMatches = [];
      console.log('page', this.id);
      console.log('returnFrom', returnFrom);
      // Check if returning from an update - if so, refresh data
      if (returnFrom === 'update') {
        this.userData = [];
        this.filteredUserData = [];
        this.manageUserService.clearUserSearchCache();
      }
      if (this.id === 'pending-users') {
        console.log("Inside IF");
        this.headder = 'Create User Profiles'
        //this.pendingUsers();
        //this.pendingUsers("pending");
        this.pendingUserSearch("pending");
        this.displayedColumns = ['id', 'first_name', 'last_name', 'middle_name', 'email_address', 'user_type', 'sales_rep_id', 'commission_plan', 'assc_corps', 'sales_rep_channel', 'employeeId', 'current_rec_flag', 'soft_termination_date', 'operator_id', 'sales_rep_type'];
        this.hide = true;
      } else {
        //console.log("ELse: " + JSON.stringify(this.userModel));
        //console.log(this.userModel.);
        this.userSearch("complete");
      }
      this.init();
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  private init() {
    //this.initializeColumns();
    // this.initializeExcelHeaders();
  }

  userSearch(profilestatus: string) {
    console.log(this.userModel);
    this.userModel1 = null;
    this.userModel1 = JSON.parse(JSON.stringify(this.userModel));

    let status = 0;
    if (this.userModel.first_name) {
      console.log("Inside first_name");
      status = 1;
    } else if (this.userModel.last_name) {
      console.log("Inside last_name");
      status = 1;
    } else if (this.userModel.employeeId) {
      console.log("Inside employeeId");
      status = 1;
    } else if (this.userModel.sales_rep_id) {
      console.log("Inside sales_rep_id");
      status = 1;
    } else if (this.userModel.id) {
      console.log("Inside id");
      status = 1;
    } else if (this.userModel.supervisor_id) {
      console.log("Inside supervisor_id");
      status = 1;
    } else if (this.userModel.user_type) {
      console.log("Inside user_type");
      status = 1;
    } else if (this.userModel.sales_rep_channel) {
      console.log("Inside sales_rep_channel");
      status = 1;
    } else if (this.userModel.comm_plan_id) {
      console.log("Inside comm_plan_id");
      status = 1;
    } else if (this.userModel.payroll_start_date) {
      console.log("Inside payroll_start_date");
      status = 1;
    } else if (this.userModel.soft_termination_date) {
      console.log("Inside soft_termination_date");
      status = 1;
    } else {
      status = 0;
    }
    console.log("status = " + status);
    if (status == 0) {
      //this.uprofileData = [];
      //this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
      this.redirect('manage-users');
    } else {
      if (this.userModel1.first_name) {
      } else {
        this.userModel1.first_name = "NA";
      }
      if (this.userModel1.last_name) {
      } else {
        this.userModel1.last_name = "NA";
      }
      if (this.userModel1.employeeId) {
      } else {
        this.userModel1.employeeId = "NA";
      }
      if (this.userModel1.sales_rep_id) {
      } else {
        this.userModel1.sales_rep_id = "NA";
      }
      if (this.userModel1.user_type) {
      } else {
        this.userModel1.user_type = "NA";
      }
      if (this.userModel1.id) {
      } else {
        this.userModel1.id = "NA";
      }
      if (this.userModel1.supervisor_id) {
      } else {
        this.userModel1.supervisor_id = 0;
      }
      if (this.userModel1.comm_plan_id) {
      } else {
        this.userModel1.comm_plan_id = 0;
      }
      if (this.userModel1.sales_rep_channel) {
      } else {
        this.userModel1.sales_rep_channel = "NA";
      }
      if (this.userModel1.soft_termination_date) {
      } else {
        this.userModel1.soft_termination_date = null;
      }

      const cacheKey = JSON.stringify({
        profilestatus,
        first_name: this.userModel1.first_name,
        last_name: this.userModel1.last_name,
        employeeId: this.userModel1.employeeId,
        sales_rep_id: this.userModel1.sales_rep_id,
        soft_termination_date: this.userModel1.soft_termination_date,
        id: this.userModel1.id,
        supervisor_id: this.userModel1.supervisor_id,
        user_type: this.userModel1.user_type,
        sales_rep_channel: this.userModel1.sales_rep_channel,
        comm_plan_id: this.userModel1.comm_plan_id,
        payroll_start_date: this.userModel1.payroll_start_date,
        userRole: this.userModel1.userRole
      });

      if (this.manageUserService.userSearchCacheKey === cacheKey && this.manageUserService.userSearchCacheData?.length > 0) {
        const cachedData = JSON.parse(JSON.stringify(this.manageUserService.userSearchCacheData));
        this.userData = cachedData;
        this.filteredUserData = JSON.parse(JSON.stringify(cachedData));
        this.userData.forEach(user => {
          if (user.first_name && user.last_name) {
            user.name = `${user.last_name}, ${user.first_name}`;
          }
        });
        this.filteredUserData.forEach(user => {
          if (user.first_name && user.last_name) {
            user.name = `${user.last_name}, ${user.first_name}`;
          }
        });
        this.syncTerminationDisplayFields(this.userData);
        this.syncTerminationDisplayFields(this.filteredUserData);
        this.filterUsers();
        this.getSuperVisors();
        return;
      }

      this.manageUserService.getUsers(profilestatus, this.userModel1.first_name, this.userModel1.last_name, this.userModel1.employeeId, this.userModel1.sales_rep_id, this.userModel1.soft_termination_date, this.userModel1.id, this.userModel1.supervisor_id, this.userModel1.user_type, this.userModel1.sales_rep_channel, this.userModel1.comm_plan_id, this.userModel1.payroll_start_date, this.userModel1.userRole)
        .subscribe((data: AddUser[]) => {
          this.userData = data;
          this.manageUserService.userSearchCacheKey = cacheKey;
          this.manageUserService.userSearchCacheData = JSON.parse(JSON.stringify(data || []));
          this.filteredUserData = JSON.parse(JSON.stringify(data));
          console.log(this.userData);
          // Format employee names to "Lastname, Firstname" format
          this.userData.forEach(user => {
            if (user.first_name && user.last_name) {
              user.name = `${user.last_name}, ${user.first_name}`;
            }
          });
          this.filteredUserData.forEach(user => {
            if (user.first_name && user.last_name) {
              user.name = `${user.last_name}, ${user.first_name}`;
            }
          });
          this.syncTerminationDisplayFields(this.userData);
          this.syncTerminationDisplayFields(this.filteredUserData);
          // console.log(this.filteredUserData);
          this.filterUsers();
          this.getSuperVisors();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
  }

  pendingUserSearch(profilestatus: string) {
    console.log(this.userModel);
    this.userModel1 = null;
    this.userModel1 = JSON.parse(JSON.stringify(this.userModel));

    let status = 0;
    if (this.userModel.first_name) {
      console.log("Inside first_name");
      status = 1;
    } else if (this.userModel.last_name) {
      console.log("Inside last_name");
      status = 1;
    } else if (this.userModel.employeeId) {
      console.log("Inside employeeId");
      status = 1;
    } else if (this.userModel.id) {
      console.log("Inside id");
      status = 1;
    } else {
      status = 0;
    }
    console.log("status = " + status);
    if (status == 0) {
      //this.uprofileData = [];
      //this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
      this.redirect('manage-users');
    } else {

      if (this.userModel1.first_name) {
      } else {
        this.userModel1.first_name = "NA";
      }
      if (this.userModel1.last_name) {
      } else {
        this.userModel1.last_name = "NA";
      }
      if (this.userModel1.employeeId) {
      } else {
        this.userModel1.employeeId = "NA";
      }
      if (this.userModel1.id) {
      } else {
        this.userModel1.id = "NA";
      }


      console.log(profilestatus);

      this.manageUserService.getUsersPending(profilestatus, this.userModel1.first_name, this.userModel1.last_name, this.userModel1.employeeId, this.userModel1.id, this.userModel1.userRole)
        .subscribe((data: AddUser[]) => {
          this.userData = data;
          //this.filteredUserData = JSON.parse(JSON.stringify(data));
          console.log(this.userData);
          // Format employee names to "Lastname, Firstname" format
          this.userData.forEach(user => {
            if (user.first_name && user.last_name) {
              user.name = `${user.last_name}, ${user.first_name}`;
            }
          });
          if (this.userData.length > 0) {
            this.filterPendingUsers();
          } else {
            this.handleNoPendingMatch();
          }
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
  }

  private shouldRedirectToCreateNewUser(): boolean {
    return !!(
      this.userModel.employeeId ||
      this.userModel.id ||
      this.userModel.first_name ||
      this.userModel.last_name
    );
  }

  private shouldCheckActiveUserBeforeCreate(): boolean {
    return !!(this.userModel.employeeId || this.userModel.id);
  }

  private handleNoPendingMatch(): void {
    if (this.shouldCheckActiveUserBeforeCreate()) {
      this.resolvePendingSearchOutcome();
      return;
    }
    if (this.shouldRedirectToCreateNewUser()) {
      this.redirectToCreateNewUser();
      return;
    }
    this.notificationService.notify(NotificationType.ERROR, "No Match Found With Your Search Criteria");
    this.router.navigate(['/pending-users']);
  }

  private buildCompleteUserSearchModel(): AddUser {
    const model = JSON.parse(JSON.stringify(this.userModel));
    model.first_name = model.first_name || 'NA';
    model.last_name = model.last_name || 'NA';
    model.employeeId = model.employeeId || 'NA';
    model.sales_rep_id = model.sales_rep_id || 'NA';
    model.id = model.id || 'NA';
    model.supervisor_id = model.supervisor_id || 0;
    model.user_type = model.user_type || 'NA';
    model.sales_rep_channel = model.sales_rep_channel || 'NA';
    model.comm_plan_id = model.comm_plan_id || 0;
    model.payroll_start_date = model.payroll_start_date || 'null';
    model.soft_termination_date = model.soft_termination_date || null;
    return model;
  }

  private resolvePendingSearchOutcome(): void {
    const searchModel = this.buildCompleteUserSearchModel();
    this.manageUserService.getUsers(
      'complete',
      searchModel.first_name,
      searchModel.last_name,
      searchModel.employeeId,
      searchModel.sales_rep_id,
      searchModel.soft_termination_date,
      searchModel.id,
      searchModel.supervisor_id,
      searchModel.user_type,
      searchModel.sales_rep_channel,
      searchModel.comm_plan_id,
      searchModel.payroll_start_date,
      searchModel.userRole
    ).subscribe((activeUsers: AddUser[]) => {
      const matches = this.filterActiveUserMatches(activeUsers || []);
      if (matches.length > 0) {
        this.showActiveUserNotice(matches);
        return;
      }
      if (this.shouldRedirectToCreateNewUser()) {
        this.redirectToCreateNewUser();
        return;
      }
      this.notificationService.notify(NotificationType.ERROR, "No Match Found With Your Search Criteria");
      this.router.navigate(['/pending-users']);
    }, (errorResponse: HttpErrorResponse) => {
      this.notificationService.sendNotification(NotificationType.ERROR, this.toErrorMessage(errorResponse));
      this.router.navigate(['/pending-users']);
    });
  }

  private toErrorMessage(error: HttpErrorResponse): string {
    return error?.error?.message || error?.message || 'Unexpected error';
  }

  private filterActiveUserMatches(users: AddUser[]): AddUser[] {
    if (this.userModel.employeeId) {
      const employeeId = this._normalizeValue(this.userModel.employeeId);
      return users.filter(user => this._normalizeValue(user.employeeId) === employeeId);
    }
    if (this.userModel.id) {
      return users.filter(user => String(user.id) === String(this.userModel.id));
    }
    return users;
  }

  private showActiveUserNotice(matches: AddUser[]): void {
    this.activeUserNotice = true;
    this.activeUserMatches = matches;
    this.filteredUserData = [];
    this.userData = [];
    this.dataSource.data = [];
    const match = matches[0];
    this.activeUserPersonId = match?.employeeId || this.userModel.employeeId || 'N/A';
    this.activeUserCompasId = match?.id || this.userModel.id || '';
    this.activeUserDisplayName = match?.first_name && match?.last_name
      ? `${match.last_name}, ${match.first_name}`
      : '';
    this.activeUserNoticeMessage =
      'This person already has an active profile in COMPAS. Please click on "Go to User Profile" to view or update their records.';
  }

  goToManageUsersForActiveUser(): void {
    const match = this.activeUserMatches[0];
    const prefill = new AddUser();
    prefill.employeeId = this.userModel.employeeId || match?.employeeId || null;
    prefill.id = this.userModel.id || match?.id || null;
    prefill.first_name = this.userModel.first_name || match?.first_name || null;
    prefill.last_name = this.userModel.last_name || match?.last_name || null;
    this.manageUserService.userModel = prefill;
    this.router.navigate(['/manage-users'], {
      queryParams: {
        autoSearch: 'true',
        returnTo: this.returnTo || 'pending-users'
      }
    });
  }

  backToPendingUsers(): void {
    this.activeUserNotice = false;
    this.router.navigate(['/pending-users']);
  }

  private redirectToCreateNewUser() {
    const prefill = new AddUser();
    prefill.employeeId = this.userModel.employeeId || null;
    prefill.id = this.userModel.id || null;
    prefill.first_name = this.userModel.first_name || null;
    prefill.last_name = this.userModel.last_name || null;
    this.manageUserService.userModel = prefill;
    this.manageUserService.selectedUserModel = new AddUser();

    this.router.navigate(['/new-users'], {
      queryParams: {
        page: 'newUser',
        returnTo: this.returnTo || 'pending-users'
      }
    });
  }

  filterPendingUsers() {
    console.log(this.userModel);
    console.log("Inside filterUsers()");
    console.log(' this.userModel comm_plan_id ==', this.userModel.comm_plan_id);
    console.log("Inside filterUsers ELSE");
    if (this.userModel.first_name) {
      console.log('Inside Firstname ==', this.userModel.first_name);
      const filterValue = this._normalizeValue(this.userModel.first_name);
      console.log('filterValue ==', filterValue);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.first_name).startsWith(filterValue));
      console.log(' this.filteredUserData ==', this.filteredUserData);
      this.findData();
    }
    if (this.userModel.last_name) {

      const filterValue = this._normalizeValue(this.userModel.last_name);
      this.filteredUserData = (this.userData.filter(user => this._normalizeValue(user.last_name).startsWith(filterValue)));
      this.findData();
    }
    if (this.userModel.employeeId) {

      const filterValue = this._normalizeValue(this.userModel.employeeId);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.employeeId).startsWith(filterValue));
      this.findData();
    }
    if (this.userModel.id) {
      this.filteredUserData = this.userData.filter((user) => (user.id == this.userModel.id));
      this.findData();
    }
    if (this.filteredUserData.length > 0) {
      this.dataSource.data = this.filteredUserData;
      this.filteredUserData.forEach((data) => {
        this.curDate = data.curDate;
        this.prevDateOne = data.prevDateOne;
        this.prevDateTwo = data.prevDateTwo;
      });
      this.initializePendingColumns();
      return;
    }

    this.handleNoPendingMatch();
  }


  filterUsers() {
    console.log(this.userModel);
    console.log("Inside filterUsers()");
    console.log(' this.userModel comm_plan_id ==', this.userModel.comm_plan_id);
    console.log("Inside filterUsers ELSE");
    if (this.userModel.first_name) {
      console.log('Inside Firstname ==', this.userModel.first_name);
      const filterValue = this._normalizeValue(this.userModel.first_name);
      console.log('filterValue ==', filterValue);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.first_name).startsWith(filterValue));
      console.log(' this.filteredUserData ==', this.filteredUserData);
      this.findData();
    }
    if (this.userModel.last_name) {
      const filterValue = this._normalizeValue(this.userModel.last_name);
      this.filteredUserData = (this.userData.filter(user => this._normalizeValue(user.last_name).startsWith(filterValue)));
      this.findData();
    }
    if (this.userModel.employeeId) {
      const filterValue = this._normalizeValue(this.userModel.employeeId);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.employeeId).startsWith(filterValue));
      this.findData();
    }
    if (this.userModel.id) {
      this.filteredUserData = this.userData.filter((user) => (user.id == this.userModel.id));
      this.findData();
    }
    if (this.userModel.supervisor_id) {
      this.filteredUserData = this.userData.filter((user) => (user.supervisor_id == this.userModel.supervisor_id));
      this.findData();
    }
    if (this.userModel.user_type) {
      const filterValue = this._normalizeValue(this.userModel.user_type);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.user_type).startsWith(filterValue));
      this.findData();
    }
    console.log(this.userModel.sales_rep_channel);
    if (this.userModel.sales_rep_channel) {
      console.log("Inside IF");
      const filterValue = this._normalizeValue(this.userModel.sales_rep_channel);
      this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.sales_rep_channel).startsWith(filterValue));
      this.findData();
    }
    console.log(this.filteredUserData);
    if (this.userModel.comm_plan_id) {
      this.filteredUserData = this.userData.filter((user) => (user.comm_plan_id == this.userModel.comm_plan_id));
      console.log(this.filteredUserData);
      this.findData();
    }

    console.log("payroll_start_date = " + this.userModel.payroll_start_date);
    console.log("payroll_end_date = " + this.userModel.payroll_start_date);

    if (this.userModel.payroll_start_date) {
      this.filteredUserData = this.userData.filter((user) =>
        (user.effective_date <= this.userModel.payroll_start_date));

      console.log("filteredUserData = " + this.filteredUserData);
      this.findData();
    }

    console.log('this.filteredUserData.length 2 ==', this.filteredUserData.length);

    if (this.filteredUserData.length > 0) {
      this.dataSource.data = this.filteredUserData;
    } else if (this.shouldRedirectToCreateNewUser()) {
      this.redirectToCreateNewUser();
    } else {
      this.notificationService.notify(NotificationType.ERROR, "No Match Found With Your Search Criteria");
      this.router.navigate(['/pending-users']);
    }

    this.filteredUserData.forEach((data) => {
      this.curDate = data.curDate;
      this.prevDateOne = data.prevDateOne;
      this.prevDateTwo = data.prevDateTwo;
    });

    this.initializeColumns();
    this.initializeExcelHeaders();
  }

  private findData() {
    if (this.filteredUserData.length > 0) {
      this.userData = this.filteredUserData;
      console.log(this.userData);
    }
  }

  pendingUsers(profilestatus: string) {
    console.log("Inside pendingUsers()");
    this.userModel.first_name = null;
    //console.log("payroll_end_date = " + this.userModel.payroll_end_date);
    this.manageUserService.searchUsers(profilestatus, this.userModel.payroll_end_date)
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        this.filteredUserData = data;
        //console.log(this.userData.length);
        //console.log("userData = " + JSON.stringify(this.userData));

        this.getSuperVisors();
        // this.filterUsers();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  initializeExcelHeaders(): void {
    this.excelHeadersService.getKPIExcelHeaders()
      .subscribe((data: any) => {
        // this.columnsDataJson = JSON.parse(JSON.stringify(data));
        this.columnsExcelData = JSON.parse(JSON.stringify(data));

        console.log(this.columnsExcelData);
        this.columnsExcelData = this.columnsExcelData.filter((kpi: { pagename: string; }) => kpi.pagename === "ExcelUsersData");
        console.log(this.columnsExcelData);
        var obj = [];
        for (let val of this.columnsExcelData) {
          if (val.name === "Comm Plan1") {
            val.name = "CommPlan " + this.curDate;
          } else if (val.name === "Comm Plan2") {
            val.name = "CommPlan " + this.prevDateOne;
          } else if (val.name === "Comm Plan3") {
            val.name = "CommPlan " + this.prevDateTwo;
          }

          if (val.name === "Supervisor1") {
            val.name = "Supervisor " + this.curDate;
          } else if (val.name === "Supervisor2") {
            val.name = "Supervisor " + this.prevDateOne;
          } else if (val.name === "Supervisor3") {
            val.name = "Supervisor " + this.prevDateTwo;
          }

          obj[val.name] = val.name;
          // console.log(obj);
        }
        this.ordersTableExcelHeaderColumns = obj;
        console.log(this.ordersTableExcelHeaderColumns);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  public exportExcel() {
    this.exportExcelUserData = null;
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.filteredUserData));

    console.log(this.exportExcelUserData);

    for (let js of this.exportExcelUserData) {
      delete js.email_address;
      delete js.userRole;
      delete js.sales_rep_channel_desc;
      delete js.joining_date;
      delete js.work_status;
      delete js.termination_date;
      delete js.vacation_start_date;
      delete js.vacation_end_date;
      delete js.assc_corps;
      delete js.created_dt;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.supervisor_name;
      delete js.supervisor_id
      delete js.supervisor_pref_name;
      delete js.pref_first_name;
      delete js.pref_last_name;
      delete js.std_hours;
      delete js.commPlanId;
      delete js.corp;
      delete js.language;
      delete js.commissionable;
      delete js.calendar_type;
      delete js.first_name;
      delete js.middle_name;
      delete js.last_name;
      delete js.activeCommPeriod;
      delete js.effective_date;
      delete js.soft_termination_date;
      delete js.curDate;
      delete js.prevDateOne;
      delete js.prevDateTwo;
      delete js.supname;
      delete js.sales_channel_desc;
    }
    this.dataForExcel = [];
    let reportData = null;

    this.exportExcelUserData.forEach((obj) => {
      if (obj.comm_plan_id != null) {
        obj.comm_plan_id = Number(String(obj.comm_plan_id).replace("$", ""));
      }
      if (obj.comPlan == null) {
        delete obj.comPlan
        delete obj.rowid
      }
    })

    console.log(this.exportExcelUserData);

    this.exportExcelUserData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row));
      //console.log(this.dataForExcel);
    })
    reportData = {
      title: 'Personnel Report',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns)
    }
    this.exportExcelService.exportExcel(reportData);
  }

  move(array, oldIndex, newIndex) {
    if (newIndex >= array.length) {
      newIndex = array.length - 1;
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    return array;
  }

  // changed(values: any) {
  //   // Store the currently selected user before refreshing data
  //   this.isChecked = values.value.currentTarget.checked;
  //   // this.isUserInteracting = true;
  //   this.selectedUser = [];
  //   this.manageUserService.selectedUserModel = new AddUser();
  //   this.manageUserService.selectedUserDocModel = [];
  //   if (values.value.currentTarget.checked == true) {
  //     this.getUsersIncludingInactive();
  //   }
  //   else {
  //     this.userSearch("complete");
  //   }
  // }
  changed(values: any) {
    // Only update the checkbox state for popup - do NOT refresh main table data
    this.isChecked = values.value.currentTarget.checked;
    console.log('Include inactive checkbox changed to:', this.isChecked, '(affects popup only, main table unchanged)');

    // Do NOT refresh the main table data
    // The checkbox now only affects popup behavior when getAsOfDate() is called
  }
  getUsersIncludingInactive() {
    console.log('Getting both active and inactive users for main table (showing unique users only)');
    this.userModel1 = null;
    this.userModel1 = JSON.parse(JSON.stringify(this.userModel));
    this.userModel1.first_name = this.userModel1.first_name || "NA";
    this.userModel1.last_name = this.userModel1.last_name || "NA";
    this.userModel1.employeeId = this.userModel1.employeeId || "NA";
    this.userModel1.sales_rep_id = this.userModel1.sales_rep_id || "NA";
    this.userModel1.user_type = this.userModel1.user_type || "NA";
    this.userModel1.id = this.userModel1.id || "NA";
    this.userModel1.supervisor_id = this.userModel1.supervisor_id || 0;
    this.userModel1.comm_plan_id = this.userModel1.comm_plan_id || 0;
    this.userModel1.sales_rep_channel = this.userModel1.sales_rep_channel || "NA";
    this.userModel1.soft_termination_date = this.userModel1.soft_termination_date || null;

    // First get active users (complete)
    this.manageUserService.getUsers('complete', this.userModel1.first_name, this.userModel1.last_name, this.userModel1.employeeId, this.userModel1.sales_rep_id, this.userModel1.soft_termination_date, this.userModel1.id, this.userModel1.supervisor_id, this.userModel1.user_type, this.userModel1.sales_rep_channel, this.userModel1.comm_plan_id, this.userModel1.payroll_start_date, this.userModel1.userRole)
      .subscribe((activeData: AddUser[]) => {
        console.log('Active users received:', activeData);
        // Then get inactive users
        this.manageUserService.getUsers('inactive', this.userModel1.first_name, this.userModel1.last_name, this.userModel1.employeeId, this.userModel1.sales_rep_id, this.userModel1.soft_termination_date, this.userModel1.id, this.userModel1.supervisor_id, this.userModel1.user_type, this.userModel1.sales_rep_channel, this.userModel1.comm_plan_id, this.userModel1.payroll_start_date, this.userModel1.userRole)
          .subscribe((inactiveData: AddUser[]) => {
            console.log('Inactive users received:', inactiveData);
            // Combine both active and inactive data - show ALL rows when include inactive is checked
            const combinedData = [...(activeData || []), ...(inactiveData || [])];
            console.log('Combined data (all rows including inactive):', combinedData.length, 'records');

            this.userData = combinedData;
            this.filteredUserData = JSON.parse(JSON.stringify(combinedData));
            console.log('All user data for main table (active + inactive):', this.userData.length, 'records');
            // Format employee names to "Lastname, Firstname" format
            this.userData.forEach(user => {
              if (user.first_name && user.last_name) {
                user.name = `${user.last_name}, ${user.first_name}`;
              }
            });
            this.filteredUserData.forEach(user => {
              if (user.first_name && user.last_name) {
                user.name = `${user.last_name}, ${user.first_name}`;
              }
            });
            this.filterUsers();
            this.getSuperVisors();
          }, (inactiveError) => {
            console.log('Error fetching inactive users, using only active users:', inactiveError);
            // If we can't get inactive users, just use active users
            this.userData = activeData || [];
            this.filteredUserData = JSON.parse(JSON.stringify(this.userData));
            // Format employee names to "Lastname, Firstname" format
            this.userData.forEach(user => {
              if (user.first_name && user.last_name) {
                user.name = `${user.last_name}, ${user.first_name}`;
              }
            });
            this.filteredUserData.forEach(user => {
              if (user.first_name && user.last_name) {
                user.name = `${user.last_name}, ${user.first_name}`;
              }
            });
            this.filterUsers();
            this.getSuperVisors();
          });
      }, (activeError) => {
        console.log('Error fetching active users:', activeError);
        this.notificationService.sendNotification(NotificationType.ERROR, 'Error fetching user data');
      });
  }

  userSearchByDate(effective_date: Date) {
    this.manageUserService.searchUsersByDate(effective_date)
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        //console.log("userData = " + JSON.stringify(this.userData));
        this.getSuperVisors();
        this.filterUsers();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  changedDate(values: any) {
    //console.log(values.value.target.value);
    //this.getActiveKpisByDate(values.value.target.value);
    this.userSearchByDate(values.value.target.value);
  }

  refreshPage() {
    if (this.id === 'pending-users') {
      this.pendingUserSearch('pending');
      return;
    }
    this.userSearch("complete");
  }

  customSort(sortParameters: Sort) {
    //console.log('=====', sortParameters);
    const keyName = sortParameters.active;
    if (sortParameters.direction === 'asc') {
      this.filteredUserData = this.filteredUserData.sort((a: AddUser, b: AddUser) =>
        a[keyName].localeCompare(b[keyName]));
      this.init();
    } else if (sortParameters.direction === 'desc') {
      this.filteredUserData = this.filteredUserData.sort((a: AddUser, b: AddUser) => b[keyName].localeCompare(a[keyName]));
      this.init();
    }
    else {
      this.filterUsers();
      this.init();
    }
    //console.log('=====', this.filteredUserData);
    //return this.filteredUserData ;
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  clickToCloseButton = () => {
    this.modelInstance.hide();
    this.termModelInstance.hide();
    this.resolvedAsOfDateKey = '';
    this.resolvedAsOfDateLabel = '';
    this.selectedTermDate = null;
    this.selectedTermDateInput = '';
  }

  private parseLocalDate(value: string): Date | null {
    if (!value) {
      return null;
    }
    const parts = value.split('-');
    if (parts.length !== 3) {
      return null;
    }
    const date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return isNaN(date.getTime()) ? null : date;
  }

  private formatDateYmd(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  private syncTerminationDisplayFields(users: AddUser[]): void {
    if (!users) {
      return;
    }

    users.forEach(user => {
      const termDate = user.soft_termination_date || (user as any).soft_termination_date;
      const parsed = this.toDateOnly(termDate);
      if (!parsed || parsed.getFullYear() >= 2900) {
        user.softdate = null as any;
        return;
      }

      const month = String(parsed.getMonth() + 1).padStart(2, '0');
      const day = String(parsed.getDate()).padStart(2, '0');
      user.softdate = `${month}-${day}-${parsed.getFullYear()}` as any;
    });
  }

  private buildTerminatePayload(user: AddUser) {
    const employeeId = user.employeeId || (user as any).employee_id;
    return {
      employeeId,
      id: user.id,
      rowid: user.rowid,
      soft_termination_date: this.formatDateYmd(this.selectedTermDate),
      stat: 'terminate',
      updated_by: localStorage.getItem('CURRENT_USER_NAME_SESSION') || this.authGaurdService.loginUser()
    };
  }

  private updateTerminateButtonLabel(): void {
    if (!this.buttons) {
      return;
    }
    const termButton = this.buttons.find(button => button.pagenavigation === 'terminate');
    if (termButton) {
      termButton.name = this.selectedUser.length > 1 ? 'Bulk Terminate' : 'Terminate';
    }
    this.termModalTitle = this.selectedUser.length > 1
      ? `Bulk Terminate (${this.selectedUser.length} users)`
      : 'Terminate User';
  }

  updateSelectedUser(form) {
    console.log(form)
  }

  //   getAsOfDate() {
  //     if (this.isChecked) {
  //     // NEW API for complete historical data including calendar_type
  //     this.manageUserService.getCompleteEmployeeHistory(this.selectedUserModel.employeeId)
  //       .subscribe((historyData: AddUser[]) => {
  //         this.getAsOfDateData = historyData || [];
  //         // Set profile status based on backend data or logic
  //         this.getAsOfDateData.forEach(record => {
  //           if (!record.profileStatus) {
  //             if (record.soft_termination_date && new Date(record.soft_termination_date) <= new Date()) {
  //               record.profileStatus = 'inactive';
  //             } else if (record.effective_date && new Date(record.effective_date) > new Date()) {
  //               record.profileStatus = 'pending';
  //             } else {
  //               record.profileStatus = 'complete'; // Active
  //             }
  //           }
  //             });

  //         // Row-wise filtering: Filter by selected effective date for the clicked row
  //         const selectedEffectiveDate = this.selectedUserModel.effective_date;
  //         if (selectedEffectiveDate) {
  //           const selectedDate = new Date(selectedEffectiveDate).toISOString().split('T')[0];

  //           this.getAsOfDateData = this.getAsOfDateData.filter(record => {
  //             const recordDate = new Date(record.effective_date).toISOString().split('T')[0];
  //             return recordDate === selectedDate;
  //           });
  //         }

  //         // Now assign COMPAS ID only to the filtered records for display
  //         this.getAsOfDateData.forEach(record => {
  //           // If popup data doesn't have COMPAS ID, use it from selected user
  //           if (!record.id && this.selectedUserModel.id) {
  //             record.id = this.selectedUserModel.id;
  //           }
  //         });

  //         // Remove duplicates and sort
  //         this.getAsOfDateData = this.getAsOfDateData.filter((item, index, self) =>
  //           index === self.findIndex(t => t.effective_date === item.effective_date && t.id === item.id)
  //         );
  //         this.getAsOfDateData.sort((a, b) => {
  //           const dateA = new Date(a.effective_date).getTime();
  //           const dateB = new Date(b.effective_date).getTime();
  //           return dateB - dateA; // Most recent first
  //         });
  //         this.selectedUserModel.getasofdate = this.selectedUserModel.effective_date;
  //       }, (historyError) => {
  //         // Fallback to OLD LOGIC (original working code)
  //         this.getAsOfDateProductionLogic();
  //       });
  //   } else {
  //     // If include inactive is not checked, get only active data (production logic)
  //     this.manageUserService.getUserPopupData(this.selectedUserModel.employeeId)
  //       .subscribe((data: AddUser | AddUser[]) => {
  //         this.getAsOfDateData = Array.isArray(data) ? data : [data];
  //         this.getAsOfDateData.forEach(record => {
  //           record.profileStatus = 'complete';
  //         // Only show records for the selected COMPAS ID (row-wise filtering)
  //         // Don't assign COMPAS ID to all records - let the filter handle it
  //         });

  //         // Filter by selected effective date for row-wise filtering
  //         const selectedEffectiveDate = this.selectedUserModel.effective_date;
  //         if (selectedEffectiveDate) {
  //           const selectedDate = new Date(selectedEffectiveDate).toISOString().split('T')[0];
  //           this.getAsOfDateData = this.getAsOfDateData.filter(record => {
  //             const recordDate = new Date(record.effective_date).toISOString().split('T')[0];
  //             return recordDate === selectedDate;
  //           });
  //         }

  //         // Now assign COMPAS ID only to the filtered records for display
  //         this.getAsOfDateData.forEach(record => {
  //           // If popup data doesn't have COMPAS ID, use it from selected user
  //           if (!record.id && this.selectedUserModel.id) {
  //             record.id = this.selectedUserModel.id;
  //           }
  //         });
  //         this.selectedUserModel.getasofdate = this.selectedUserModel.effective_date;
  //       }, (errorResponse: HttpErrorResponse) => {
  //         var msg: any;
  //         msg = errorResponse;
  //         this.notificationService.sendNotification(NotificationType.ERROR, msg);
  //       })
  //   }
  // }

  private toDateOnly(dateInput: any): Date | null {
    if (!dateInput) {
      return null;
    }

    // Calendar dates must not be shifted by timezone.
    // "2026-08-31" / "2026-08-31T00:00:00.000Z" should stay Aug 31, not become Aug 30 in US timezones.
    if (typeof dateInput === 'string') {
      const trimmed = dateInput.trim();
      const isoDay = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoDay) {
        return new Date(Number(isoDay[1]), Number(isoDay[2]) - 1, Number(isoDay[3]));
      }
      const usDay = trimmed.match(/^(\d{2})-(\d{2})-(\d{4})/);
      if (usDay) {
        return new Date(Number(usDay[3]), Number(usDay[1]) - 1, Number(usDay[2]));
      }
    }

    const parsed = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(parsed.getTime())) {
      return null;
    }

    // JSON/JDBC date-only values are typically midnight UTC for that calendar day
    return new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
  }

  private getMonthStart(dateInput: Date = new Date()): Date {
    return new Date(dateInput.getFullYear(), dateInput.getMonth(), 1);
  }

  private recordKey(record: AddUser): string {
    return `${record?.id || 'NA'}|${record?.effective_date || 'NA'}`;
  }

  private normalizeProfileStatus(record: AddUser): string {
    if (record?.profileStatus) {
      return record.profileStatus;
    }
    const today = this.toDateOnly(new Date());
    const effectiveDate = this.toDateOnly(record?.effective_date);
    const softTermDate = this.toDateOnly(record?.soft_termination_date);
    if (softTermDate && softTermDate <= today) {
      return 'inactive';
    }
    if (effectiveDate && effectiveDate > today) {
      return 'pending';
    }
    return 'complete';
  }

  private isActiveAtMonthStart(record: AddUser, monthStart: Date): boolean {
    const effectiveDate = this.toDateOnly(record?.effective_date);
    const softTermDate = this.toDateOnly(record?.soft_termination_date);
    if (!effectiveDate || effectiveDate > monthStart) {
      return false;
    }
    return !softTermDate || softTermDate >= monthStart;
  }

  private resolveCurrentMonthRecord(records: AddUser[], monthStart: Date): AddUser | null {
    const currentMonthCandidates = records.filter(record => this.isActiveAtMonthStart(record, monthStart));
    if (currentMonthCandidates.length === 0) {
      return null;
    }
    return currentMonthCandidates.sort((a, b) =>
      (this.toDateOnly(b?.effective_date)?.getTime() || 0) - (this.toDateOnly(a?.effective_date)?.getTime() || 0)
    )[0];
  }

  private resolveLatestPriorRecord(records: AddUser[], monthStart: Date): AddUser | null {
    const priorCandidates = records.filter(record => {
      const effectiveDate = this.toDateOnly(record?.effective_date);
      return !!effectiveDate && effectiveDate < monthStart;
    });
    if (priorCandidates.length === 0) {
      return null;
    }
    return priorCandidates.sort((a, b) =>
      (this.toDateOnly(b?.effective_date)?.getTime() || 0) - (this.toDateOnly(a?.effective_date)?.getTime() || 0)
    )[0];
  }

  private applyResolvedDefault(records: AddUser[]): AddUser | null {
    this.resolvedAsOfDateKey = '';
    this.resolvedAsOfDateLabel = '';
    if (!records || records.length === 0) {
      return null;
    }

    const monthStart = this.getMonthStart(new Date());
    const currentMonth = this.resolveCurrentMonthRecord(records, monthStart);
    const resolvedRecord = currentMonth || this.resolveLatestPriorRecord(records, monthStart) || records[0];
    const resolvedLabel = currentMonth ? 'Current Month Active' : 'Fallback Active';

    if (!resolvedRecord) {
      return null;
    }

    this.resolvedAsOfDateKey = this.recordKey(resolvedRecord);
    this.resolvedAsOfDateLabel = resolvedLabel;
    this.selectedUserModel.getasofdate = resolvedRecord.effective_date;
    this.selectedUserModel.id = resolvedRecord.id || this.selectedUserModel.id;
    this.selectedUserModel.unlock = resolvedRecord.unlock;
    return resolvedRecord;
  }

  isResolvedDefault(record: AddUser): boolean {
    return this.recordKey(record) === this.resolvedAsOfDateKey;
  }

  getResolvedDefaultLabel(record: AddUser): string {
    return this.isResolvedDefault(record) ? this.resolvedAsOfDateLabel : '';
  }

  private navigateToResolvedRecordWithoutPopup(): void {
    this.manageUserService.getCompleteEmployeeHistory(this.selectedUserModel.employeeId)
      .subscribe((historyData: AddUser[]) => {
        this.getAsOfDateData = historyData || [];
        this.getAsOfDateData.forEach(record => {
          record.profileStatus = this.normalizeProfileStatus(record);
        });

        if (!this.isChecked) {
          this.getAsOfDateData = this.getAsOfDateData.filter(record => record.profileStatus !== 'inactive');
        }

        const selectedCompasId = this.selectedUserModel.id;
        if (selectedCompasId) {
          this.getAsOfDateData = this.getAsOfDateData.filter(record => record.id === selectedCompasId);
        }

        this.getAsOfDateData = this.getAsOfDateData
          .filter((item, index, self) =>
            index === self.findIndex(t => t.effective_date === item.effective_date && t.id === item.id))
          .sort((a, b) => (new Date(b.effective_date).getTime() - new Date(a.effective_date).getTime()));

        const resolvedRecord = this.applyResolvedDefault(this.getAsOfDateData);
        if (resolvedRecord) {
          this.onChangeAsOfDate(resolvedRecord);
          return;
        }

        // If resolver returns nothing, fall back to selected row data.
        this.redirectUpdatePage();
      }, (historyError) => {
        console.error('Error fetching employee history for direct navigation:', historyError);
        this.getAsOfDateProductionLogic();
        if (this.getAsOfDateData && this.getAsOfDateData.length > 0) {
          this.onChangeAsOfDate(this.getAsOfDateData[0]);
        } else {
          this.redirectUpdatePage();
        }
      });
  }

  getAsOfDate() {
    // Always use getCompleteEmployeeHistory to get ALL records, then filter based on checkbox
    this.manageUserService.getCompleteEmployeeHistory(this.selectedUserModel.employeeId)
      .subscribe((historyData: AddUser[]) => {
        this.getAsOfDateData = historyData || [];

        // Set profile status based on backend data or logic
        this.getAsOfDateData.forEach(record => {
          record.profileStatus = this.normalizeProfileStatus(record);
        });

        // Filter based on include inactive checkbox
        if (!this.isChecked) {
          // If include inactive is NOT checked, filter out inactive records
          this.getAsOfDateData = this.getAsOfDateData.filter(record =>
            record.profileStatus !== 'inactive'
          ); // Row-wise filtering: Filter by selected COMPAS ID (not just effective date)
          // This ensures we only show records for the specific COMPAS ID that was clicked
          const selectedCompasId = this.selectedUserModel.id;
          if (selectedCompasId) {
            this.getAsOfDateData = this.getAsOfDateData.filter(record => {
              return record.id === selectedCompasId;
            });
          }

        } else {
          // If include inactive IS checked, show all records for the selected COMPAS ID
          // Apply same COMPAS ID filtering for consistency
          const selectedCompasId = this.selectedUserModel.id;
          if (selectedCompasId) {
            this.getAsOfDateData = this.getAsOfDateData.filter(record => {
              return record.id === selectedCompasId;
            });
          }

        }
        // Assign COMPAS ID to records for display
        this.getAsOfDateData.forEach(record => {
          if (!record.id && this.selectedUserModel.id) {
            record.id = this.selectedUserModel.id;
          }
        });

        // Remove duplicates and sort
        this.getAsOfDateData = this.getAsOfDateData.filter((item, index, self) =>
          index === self.findIndex(t => t.effective_date === item.effective_date && t.id === item.id)
        );
        this.getAsOfDateData.sort((a, b) => {
          const dateA = new Date(a.effective_date).getTime();
          const dateB = new Date(b.effective_date).getTime();
          return dateB - dateA; // Most recent first
        });


        const resolvedRecord = this.applyResolvedDefault(this.getAsOfDateData);
        if (resolvedRecord) {
          this.getAsOfDateData = [resolvedRecord];
        }
      }, (historyError) => {
        console.error('Error fetching employee history:', historyError);
        // Fallback to OLD LOGIC (original working code)
        this.getAsOfDateProductionLogic();
      });
  }

  // Old Logic Backup - the original working method
  getAsOfDateProductionLogic() {
    this.manageUserService.getUserPopupData(this.selectedUserModel.employeeId)
      .subscribe((activeData: AddUser | AddUser[]) => {
        let activeRecords = Array.isArray(activeData) ? activeData : [activeData];
        activeRecords.forEach(record => {
          record.profileStatus = 'complete';
          // If popup data doesn't have COMPAS ID, use it from selected user
          if (!record.id && this.selectedUserModel.id) {
            record.id = this.selectedUserModel.id;
          }
        });
        // Then get inactive data and combine
        this.manageUserService.getUsers('inactive', 'NA', 'NA', this.selectedUserModel.employeeId, 'NA', null, 'NA', 0, 'NA', 'NA', 0, null, null)
          .subscribe((inactiveData: AddUser[]) => {
            let inactiveRecords = inactiveData || [];
            inactiveRecords.forEach(record => {
              record.profileStatus = 'inactive';
              // If popup data doesn't have COMPAS ID, use it from selected user
              if (!record.id && this.selectedUserModel.id) {
                record.id = this.selectedUserModel.id;
              }
            });
            // Combine both active and inactive records
            this.getAsOfDateData = [...activeRecords, ...inactiveRecords];
            // Assign COMPAS ID only to the filtered records
            this.getAsOfDateData.forEach(record => {
              if (!record.id && this.selectedUserModel.id) {
                record.id = this.selectedUserModel.id;
              }
            });
            // Remove duplicates based on effective_date and id
            this.getAsOfDateData = this.getAsOfDateData.filter((item, index, self) =>
              index === self.findIndex(t => t.effective_date === item.effective_date && t.id === item.id)
            );
            // Sort by effective_date most recent first
            this.getAsOfDateData.sort((a, b) => {
              const dateA = new Date(a.effective_date).getTime();
              const dateB = new Date(b.effective_date).getTime();
              return dateB - dateA; // Descending order (newest first)
            });
            const resolvedRecord = this.applyResolvedDefault(this.getAsOfDateData);
            if (resolvedRecord) {
              this.getAsOfDateData = [resolvedRecord];
            }
          }, (inactiveError) => {
            // If we can't get inactive records, just use active records
            this.getAsOfDateData = activeRecords;
            const resolvedRecord = this.applyResolvedDefault(this.getAsOfDateData);
            if (resolvedRecord) {
              this.getAsOfDateData = [resolvedRecord];
            }
          });
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  onChangeAsOfDate(data: AddUser) {
    this.selectedUserModel.getasofdate = data.effective_date;
    this.selectedUserModel.id = data.id || this.selectedUserModel.id;
    this.selectedUserModel.unlock = data.unlock;
    // Make API call to get the complete user data for the selected effective date
    this.manageUserService.getUserByAsOfDt(this.selectedUserModel.employeeId, this.selectedUserModel.getasofdate, this.selectedUserModel.id)
      //this.manageUserService.getUserByAsOfDt(this.selectedUserModel.id || this.selectedUserModel.employeeId, this.selectedUserModel.getasofdate, this.selectedUserModel.id)
      .subscribe((responseData: any) => {
        // Handle the response - find record matching the clicked COMPAS ID
        let userData;
        if (Array.isArray(responseData)) {
          // Find record with matching COMPAS ID
          userData = responseData.find(record => record.id === data.id);
          if (!userData) {
            userData = responseData[0];
          }
        } else {
          userData = responseData;
        }
        if (userData) {
          this.selectedUserModel = userData;
          this.selectedUserModel.getasofdate = this.selectedUserModel.effective_date;
          // Set commission plan
          if (this.selectedUserModel.comm_plan_id != null) {
            const planData = this.manageUserService.comPlansUserData.filter(com => com.comm_plan_id == this.selectedUserModel.comm_plan_id);
            if (planData.length > 0) {
              this.selectedUserModel.commission_plan = planData[0].commission_plan;
            } else {
              this.selectedUserModel.commission_plan = "N/A";
            }
          } else {
            this.selectedUserModel.commission_plan = "N/A";
          }
          // Set supervisor name
          if (!this.selectedUserModel.supervisor_name) {
            this.selectedUserModel.supervisor_name = "N/A";
          }
          this.redirectUpdatePage();
        } else {
          console.error('No user data received from API');
          // For ADMIN users, use original search data (has complete profile info)
          // For future dates or incomplete popup data, use popup data completely
          if (this.selectedUser && this.selectedUser.length > 0 &&
            (!data.first_name || !data.last_name || !data.effective_date)) {
            this.selectedUserModel = { ...this.selectedUser[0] };
            // But preserve the clicked COMPAS ID and effective date
            this.selectedUserModel.id = data.id;
            this.selectedUserModel.effective_date = data.effective_date;
          } else {
            // Use popup data completely - has all the correct field values for the selected record
            // Fallback to popup data if no search data available
            this.selectedUserModel = { ...data };
          }

          this.selectedUserModel.getasofdate = data.effective_date || this.selectedUserModel.effective_date;
          this.selectedUserModel.unlock = data.unlock;
          this.redirectUpdatePage();
        }
      }, (errorResponse: HttpErrorResponse) => {
        console.error('Error calling getUserByAsOfDt API:', errorResponse);
        // For ADMIN users, use original search data (has complete profile info)
        // For future dates or incomplete popup data, use popup data completely
        if (this.selectedUser && this.selectedUser.length > 0 &&
          (!data.first_name || !data.last_name || !data.effective_date)) {
          this.selectedUserModel = { ...this.selectedUser[0] };
        } else {
          // Use popup data completely - has all the correct field values for the selected record
          // Fallback to popup data if no search data available
          this.selectedUserModel = { ...data };
        }
        this.selectedUserModel.getasofdate = data.effective_date || this.selectedUserModel.effective_date;
        // Set commission plan
        if (this.selectedUserModel.comm_plan_id != null) {
          const planData = this.manageUserService.comPlansUserData.filter(com => com.comm_plan_id == this.selectedUserModel.comm_plan_id);
          if (planData.length > 0) {
            this.selectedUserModel.commission_plan = planData[0].commission_plan;
          } else {
            this.selectedUserModel.commission_plan = "N/A";
          }
        } else {
          this.selectedUserModel.commission_plan = "N/A";
        }
        // Set supervisor name
        if (!this.selectedUserModel.supervisor_name) {
          this.selectedUserModel.supervisor_name = "N/A";
        }
        this.redirectUpdatePage();
      })
  }

  redirectUpdatePage() {
    this.clickToCloseButton();
    this.manageUserService.selectedUserModel = this.selectedUserModel;
    if (this.id === 'pending-users') {
      this.router.navigate(['/add-users'], {
        queryParams: { page: this.id, returnTo: this.returnTo || 'pending-users' }
      });
    } else {
      this.router.navigate(['/add-users'], { queryParams: { page: 'updatePersonnelUser' } });
    }
  }

  redirect(url: string) {
    console.log(url);
    console.log(this.selectedUser);
    console.log(this.id);
    if (url === 'add-users') {
      if (this.selectedUser.length === 1) {
        this.selectedUserModel = this.selectedUser[0];
        if (this.selectedUserModel.comm_plan_id != null) {
          const planData = this.manageUserService.comPlansUserData.filter(com => com.comm_plan_id == this.selectedUserModel.comm_plan_id);
          if (planData && planData.length > 0) {
            this.selectedUserModel.commission_plan = planData[0].commission_plan;
          } else {
            this.selectedUserModel.commission_plan = "N/A";
          }
          //this.selectedUserModel.commission_plan = planData[0].commission_plan;
        } else {
          this.selectedUserModel.commission_plan = "N/A";
        }
        if (!this.selectedUserModel.supervisor_name) {
          this.selectedUserModel.supervisor_name = "N/A";
        }
        //Only show popup if current page is NOT 'pending-users'
        if (this.id !== 'pending-users') {
          // Popup flow intentionally disabled (kept as comment for rollback).
          // console.log("search results pop up only");
          // this.getAsOfDate();
          // this.modelInstance.show();
          this.navigateToResolvedRecordWithoutPopup();

        } else {
          this.redirectUpdatePage();
        }
      } else {
        this.notificationService.notify(NotificationType.ERROR, "Please select only one user");
      }
    } else if (url === 'view-logins') {
      if (this.selectedUser.length === 1) {
        if (this.id === 'pending-users') {
          console.log("Inside IF");
          this.router.navigate(['/' + url], { queryParams: { page: this.id } });
        } else {
          console.log("Inside ELSE");
          this.router.navigate(['/' + url], { queryParams: { page: 'updatePersonnelUser' } });
        }
      } else {
        this.notificationService.notify(NotificationType.ERROR, "Please select only one user");
      }
    } else if (url === 'assign-document') {
      if (this.selectedUser.length > 0) {
        this.router.navigate(['/' + url]);
      } else {
        this.notificationService.notify(NotificationType.ERROR, "Please select atleast one user");
      }
    } else if (url === 'search-bulk-update') {
      this.openSearchBulkUpdate();
    } else if (url === 'add-new') {
      console.log("Inside ELSE IF 1");
      this.router.navigate(['/add-users'], { queryParams: { page: 'newUser' } });
    } else if (url === 'inactive' || url === 'terminate') {
      console.log("Inside ELSE IF 2");
      console.log("delete called:" + this.selectedUser.length);
      console.log("url:" + url);

      if (url === 'terminate') {
        if (this.selectedUser.length === 0) {
          this.notificationService.notify(NotificationType.WARNING, 'Please select at least one user');
          return;
        }
        this.selectedTermDate = null;
        this.selectedTermDateInput = '';
        this.updateTerminateButtonLabel();
        this.termModelInstance.show();
      } else {
        this.inactiveOrTerminateUsers(url);
      }

    } else {
      this.router.navigate(['/' + url]);
    }
  }

  public selectedInactiveOrTerminateUsers(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedTermDateInput = input.value;
    this.selectedTermDate = this.parseLocalDate(input.value);
  }

  public inactiveOrTerminateUsers(url: string) {
    if (url === 'terminate') {
      const termDate = this.selectedTermDate || this.parseLocalDate(this.selectedTermDateInput);
      if (!termDate) {
        this.notificationService.notify(NotificationType.ERROR, 'Please select a final termination date');
        return;
      }
      this.selectedTermDate = termDate;
    }

    const actionLabel = url === 'terminate' && this.selectedUser.length > 1 ? 'apply termination date to' : url;
    const confirmed = confirm(`Do you really want to ${actionLabel} ${this.selectedUser.length} record(s)?`);
    if (confirmed) {
      if (this.selectedUser.length > 0) {
        if (url === 'terminate') {
          const terminatePayload = this.selectedUser.map(user => this.buildTerminatePayload(user));
          const missingEmployeeId = terminatePayload.filter(item => !item.employeeId);
          if (missingEmployeeId.length > 0) {
            this.notificationService.notify(NotificationType.ERROR,
              'One or more selected users are missing Person ID and cannot be terminated.');
            return;
          }
          console.log('Terminate payload:', terminatePayload);

          this.manageUserService.deleteUser(terminatePayload as unknown as AddUser[])
            .subscribe(response => {
              this.clickToCloseButton();
              this.manageUserService.clearUserSearchCache();
              this.selectedUser = [];
              this.updateTerminateButtonLabel();
              response = response as ErrorResponseMessage;
              this.notificationService.notify(NotificationType.SUCCESS, `Termination date updated successfully`);
              this.userSearch("complete");
              this.getPrePopulatedUserData();
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any = errorResponse?.error?.message || errorResponse?.message || errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            });
          return;
        }

        for (const selectUser of this.selectedUser) {
          selectUser.soft_termination_date = new Date();
          selectUser.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION') || this.authGaurdService.loginUser();
          selectUser.stat = url;
        }

        this.manageUserService.deleteUser(this.selectedUser)
          .subscribe(response => {
            this.clickToCloseButton();
            this.manageUserService.clearUserSearchCache();
            this.selectedUser = [];
            this.updateTerminateButtonLabel();
            response = response as ErrorResponseMessage;
            this.notificationService.notify(NotificationType.SUCCESS, `Success`);
            this.userSearch("complete");
            this.getPrePopulatedUserData();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any = errorResponse?.error?.message || errorResponse?.message || errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          });

      } else {
        this.notificationService.notify(NotificationType.WARNING, `Please select users to inactivate`);
      }
    }
  }



  public pendingUsers1() {
    console.log("Inside pendingUsers()");
    //this.manageUserService.getPendingUsers()
    this.manageUserService.searchUsers("inactive", this.userModel.payroll_end_date)
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        console.log(this.userData);
        this.dataSource.data = this.userData;
        //this.filteredUserData = this.userData;
        this.filteredUserData = this.userData.filter(user => this._normalizeValue(user.first_name).startsWith("a"));
        console.log(this.filteredUserData);
        this.getPrePopulatedUserData();
        this.getSuperVisors();

        //console.log("this.userData === "+this.userData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private getSuperVisors() {
    for (let user of this.userData) {
      this.supervisorNamesSet.add(user.supervisor_name);
    }
    this.manageUserService.supervisorNamesSet = this.supervisorNamesSet;
    //console.log(this.supervisorNamesSet);
  }

  private _normalizeValue(value: string): string {
    if (value) {
      //console.log(value.toLowerCase().replace(/\s/g, ''));
      return value.toLowerCase().replace(/\s/g, '');
    }
    else
      return '';
  }

  selectedActiveKpis(user: AddUser, value: any) {
    // console.log(user);
  }

  updateUser(user: AddUser, value: any) {
    // console.log(user);
  }

  getPrePopulatedUserData() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {
      this.logger.info(data);
      this.userData = data;
      console.log(this.userData);
      for (let userInfo of this.userData) {
        if (userInfo.commission_plan != null) {
          this.comPlansUserData.push(userInfo);
        } else if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel_desc != null) {
          this.salesChnlsUserData.push(userInfo);
          this.salesChannels.push(userInfo.sales_rep_channel);
          if (this.salesChannels.length > 1) {
            this.salesChannels.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.user_type != null) {
          this.userTypes.push(userInfo.user_type)
          if (this.userTypes.length > 1) {
            this.userTypes.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.sales_rep_type != null) {
          this.salesRepTypes.push(userInfo.sales_rep_type);
          if (this.salesRepTypes.length > 1) {
            this.salesRepTypes.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.calendar_type != null) {
          this.payrollCalender.push(userInfo.calendar_type);
          if (this.payrollCalender.length > 1) {
            this.payrollCalender.sort((a, b) =>
              a.localeCompare(b));
          }
        }
      }
      //console.log("userdata===", JSON.stringify(this.comPlansUserData), " user type ", this.userTypes);
      this.allComPlansUserData = [...this.comPlansUserData];
      this.bulkFilteredComPlans = [...this.comPlansUserData];
      this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
      this.manageUserService.userTypes = this.userTypes;
      this.manageUserService.allComPlansUserData = this.comPlansUserData;
      this.manageUserService.comPlansUserData = this.comPlansUserData;
      this.manageUserService.salesRepTypes = this.salesRepTypes;
      this.manageUserService.payrollCalender = this.payrollCalender;
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    saveAs(data, fileName + this.fileExtension);
  }

  update(user: any, values: any) {
    console.log("Update called");
    console.log(values.value.currentTarget.checked);
    if (values.value.currentTarget.checked) {
      this.selectedUser.push(user.row);
    } else {
      this.selectedUser.forEach((value: any, index: any) => {
        if (value.id == user.row.id) {
          this.selectedUser.splice(index, 1);
        }
      });
    }
    console.log(this.selectedUser);
    this.manageUserService.selectedUserModel = this.selectedUser[0];
    this.manageUserService.selectedUserDocModel = this.selectedUser;
    this.updateTerminateButtonLabel();
  }

  selectAll(values: any) {
    console.log("selectAll called: " + values.value.currentTarget.checked);
    if (values.value.currentTarget.checked) {
      this.selectedUser = this.filteredUserData;
    } else {
      this.selectedUser = [];
    }
    //console.log(this.selectedUser);
    this.manageUserService.selectedUserModel = this.selectedUser[0];
    this.manageUserService.selectedUserDocModel = this.selectedUser;
    this.updateTerminateButtonLabel();
  }

  checkUncheckAll() {
    if (!this.checked) {
      this.checked = true;
      console.log("in if :", this.checked);
    } else {
      this.checked = false;
      console.log("in else :", this.checked);
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.Users;
        this.ordersTableColumns.forEach((data) => {
          if (data.name === "Comm Plan1") {
            data.name = "CommPlan " + this.curDate;
          } else if (data.name === "Comm Plan2") {
            data.name = "CommPlan " + this.prevDateOne;
          } else if (data.name === "Comm Plan3") {
            data.name = "CommPlan " + this.prevDateTwo;
          }

          if (data.name === "Supervisor1") {
            data.name = "Supervisor " + this.curDate;
          } else if (data.name === "Supervisor2") {
            data.name = "Supervisor " + this.prevDateOne;
          } else if (data.name === "Supervisor3") {
            data.name = "Supervisor " + this.prevDateTwo;
          }
        });

        //console.log(this.ordersTableColumns);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    if (this.id === 'pending-users') {
      this.buttons = [
        {
          name: 'Back',
          pagenavigation: 'pending-users'
        },
        {
          name: 'Update User',
          pagenavigation: 'add-users'
        }
        // ,
        // {
        //   name: 'Add New User',
        //   pagenavigation: 'add-new'
        // }
      ];
    } else {
      this.buttons = [

        {
          name: 'Back',
          pagenavigation: 'manage-users'
        },
        {
          name: 'Update',
          pagenavigation: 'add-users'
        },
        {
          name: 'Bulk Update',
          pagenavigation: 'search-bulk-update'
        },
        // {
        //   name: 'Inactive',
        //   pagenavigation: 'inactive'
        // },
        {
          name: 'Terminate',
          pagenavigation: 'terminate'
        },
        {
          name: 'View Login Activity',
          pagenavigation: 'view-logins'
        },
        {
          name: 'Assign Documents',
          pagenavigation: 'assign-document'
        }
      ];
    }
  }

  openSearchBulkUpdate(): void {
    if (this.selectedUser.length < 2) {
      this.notificationService.notify(NotificationType.WARNING, 'Please select more than one user for Bulk Update');
      return;
    }

    const channels = Array.from(new Set(
      this.selectedUser
        .map(user => (user.sales_rep_channel || '').trim())
        .filter(channel => !!channel)
    ));
    if (channels.length === 0) {
      this.notificationService.notify(
        NotificationType.WARNING,
        'Selected users do not have a Sales Channel. Bulk Update requires the same Sales Channel.'
      );
      return;
    }
    if (channels.length > 1) {
      this.notificationService.notify(
        NotificationType.WARNING,
        'Selected users have different Sales Channels. Please select users with the same Sales Channel.'
      );
      return;
    }

    if (this.manageUserService.salesChnlsUserData?.length && !this.salesChnlsUserData?.length) {
      this.salesChnlsUserData = this.manageUserService.salesChnlsUserData;
    }
    if (this.manageUserService.allComPlansUserData?.length && !this.allComPlansUserData?.length) {
      this.allComPlansUserData = this.manageUserService.allComPlansUserData;
      this.comPlansUserData = this.manageUserService.comPlansUserData || this.allComPlansUserData;
    }
    if (!this.salesChnlsUserData?.length || !this.allComPlansUserData?.length) {
      this.getPrePopulatedUserData();
    }

    const lockedChannel = channels[0];
    const channelLookup = (this.salesChnlsUserData || []).find(
      channel => channel.sales_rep_channel === lockedChannel
    );
    const channelDesc = channelLookup?.sales_rep_channel_desc
      || this.selectedUser.find(user => user.sales_rep_channel === lockedChannel)?.sales_rep_channel_desc
      || lockedChannel;

    this.bulkFormModel = new AddUser();
    this.bulkFormModel.supervisor_name = null;
    this.bulkFormModel.sales_rep_channel = lockedChannel;
    this.bulkFormModel.sales_rep_channel_desc = channelDesc;
    this.bulkFormModel.comm_plan_id = null;
    this.bulkFormModel.effective_date = null;
    this.bulkSalesChannelDisplay = channelDesc;
    this.bulkModalTitle = `Bulk Update (${this.selectedUser.length} users)`;
    this.bulkFilteredComPlans = [];
    this.loadBulkCommissionPlans(lockedChannel, channelDesc);
    this.bulkControlSup.setValue('');
    this.filterBulkSupervisors();

    if (!this.bulkUpdateModalInstance && this.bulkUpdateModalElement?.nativeElement) {
      this.bulkUpdateModalInstance = new Modal(this.bulkUpdateModalElement.nativeElement, {
        backdrop: 'static',
        keyboard: false
      });
    }
    this.bulkUpdateModalInstance?.show();
  }

  closeSearchBulkUpdate(): void {
    this.bulkUpdateModalInstance?.hide();
  }

  /** Same plan mapping as Manage Users: load plans by sales channel API. */
  private loadBulkCommissionPlans(channelCode: string, channelDesc?: string): void {
    this.bulkFilteredComPlans = [];
    this.bulkFormModel.comm_plan_id = null;
    if (!channelCode) {
      return;
    }

    this.approvalFlowService.getCommissionPlans(channelCode).subscribe(
      (plans: CommPlan[]) => {
        if ((!plans || plans.length === 0) && channelDesc && channelDesc !== channelCode) {
          this.approvalFlowService.getCommissionPlans(channelDesc).subscribe(
            (descPlans: CommPlan[]) => this.applyBulkRemotePlans(descPlans),
            (errorResponse: HttpErrorResponse) => {
              var msg: any = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          );
          return;
        }
        this.applyBulkRemotePlans(plans);
      },
      (errorResponse: HttpErrorResponse) => {
        var msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  private applyBulkRemotePlans(plans: CommPlan[]): void {
    const planOptions = (plans || []).map(plan => {
      const option = new AddUser();
      option.comm_plan_id = plan.commPlanId;
      option.commission_plan = plan.commPlan;
      return option;
    });

    this.bulkFilteredComPlans = planOptions
      .filter((plan, index, arr) =>
        arr.findIndex(x => String(x.comm_plan_id) === String(plan.comm_plan_id)) === index
      )
      .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);

    if (this.bulkFormModel.comm_plan_id != null
      && !this.bulkFilteredComPlans.some(plan => Number(plan.comm_plan_id) === Number(this.bulkFormModel.comm_plan_id))) {
      this.bulkFormModel.comm_plan_id = null;
    }
  }

  filterBulkSupervisors(): void {
    this.bulkFilteredSupValues = this.bulkControlSup.valueChanges.pipe(
      startWith(''),
      map(value => this._filterBulkSup(value || ''))
    );
  }

  private _filterBulkSup(value: string): AddUser[] {
    const filterValue = (value || '').toLowerCase();
    if (value && value.length >= 3) {
      this.manageCodesService.getEmpSupervisors(value).subscribe(
        (data: any) => { this.bulkSupervisorData = data || []; },
        (errorResponse: HttpErrorResponse) => {
          var msg: any = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
    }
    return (this.bulkSupervisorData || []).filter(item =>
      (item.supervisor_name || '').toLowerCase().includes(filterValue)
    );
  }

  trackBulkSupervisorOption(index: number, item: AddUser): string {
    return item?.supervisor_name || String(index);
  }

  private ymBulk(dateVal: any): string {
    if (typeof dateVal === 'string' && dateVal.length >= 7) {
      return dateVal.substring(0, 7);
    }
    const d = new Date(dateVal);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    return `${y}-${m}`;
  }

  saveSearchBulkUpdate(): void {
    if (this.selectedUser.length < 2) {
      this.notificationService.notify(NotificationType.WARNING, 'Please select more than one user for Bulk Update');
      return;
    }
    if (!this.bulkFormModel.effective_date) {
      this.notificationService.notify(NotificationType.ERROR, 'Please select Effective Date');
      return;
    }
    this.bulkFormModel.supervisor_name = this.bulkControlSup.value || this.bulkFormModel.supervisor_name;
    if (!this.bulkFormModel.supervisor_name) {
      this.notificationService.notify(NotificationType.ERROR, 'Please select Supervisor');
      return;
    }
    if (!this.bulkFormModel.sales_rep_channel) {
      this.notificationService.notify(NotificationType.ERROR, 'Sales Channel is required from the selected users');
      return;
    }
    if (!this.bulkFormModel.comm_plan_id) {
      this.notificationService.notify(NotificationType.ERROR, 'Please select Commission Plan');
      return;
    }

    // Locked-period same-month guard (same idea as add-users)
    const lockedSameMonth = this.selectedUser.some(user => {
      if (user.unlock !== 'N' || !user.effective_date) {
        return false;
      }
      return this.ymBulk(user.effective_date) === this.ymBulk(this.bulkFormModel.effective_date);
    });
    if (lockedSameMonth) {
      alert('Same month changes not allowed since one or more selected users are locked.');
      return;
    }

    const confirmChange = confirm(
      "The effective date will be applied to the selected users. Please clear the 'Final Termination Date' if the employee is active again. A new record will be created when the effective date differs. Do you want to continue?"
    );
    if (!confirmChange) {
      return;
    }

    let supervisorName = this.bulkFormModel.supervisor_name;
    let supervisorId: any = 0;
    const lastIndex = (supervisorName || '').lastIndexOf('-');
    if (lastIndex >= 0) {
      supervisorId = supervisorName.substring(lastIndex + 1);
      supervisorName = supervisorName.substring(0, lastIndex);
    } else {
      this.notificationService.notify(NotificationType.ERROR, 'Please select supervisor in this format NAME-EMPLOYEEID');
      return;
    }

    const selectedPlan = this.bulkFilteredComPlans.find(
      plan => Number(plan.comm_plan_id) === Number(this.bulkFormModel.comm_plan_id)
    );
    const updatedBy = localStorage.getItem('CURRENT_USER_NAME_SESSION') || this.authGaurdService.loginUser();

    const payload: AddUser[] = this.selectedUser.map(user => {
      const row = { ...user } as AddUser;
      row.effective_date = this.bulkFormModel.effective_date;
      row.supervisor_name = supervisorName;
      row.supervisor_id = supervisorId;
      // Keep each user's existing sales channel (locked from selection)
      row.sales_rep_channel = this.bulkFormModel.sales_rep_channel;
      row.sales_rep_channel_desc = this.bulkFormModel.sales_rep_channel_desc;
      row.comm_plan_id = this.bulkFormModel.comm_plan_id;
      row.commPlanId = this.bulkFormModel.comm_plan_id != null ? String(this.bulkFormModel.comm_plan_id) : null;
      row.commission_plan = selectedPlan?.commission_plan || row.commission_plan;
      row.checkboxchecked = 'false';
      row.updated_by = updatedBy;
      row.updated_dt = new Date();
      return row;
    });

    this.bulkSaving = true;
    this.manageUserService.bulkUpdate(payload).subscribe(
      () => {
        this.bulkSaving = false;
        this.notificationService.notify(NotificationType.SUCCESS, `Updated ${payload.length} users successfully`);
        this.closeSearchBulkUpdate();
        this.selectedUser = [];
        this.userSearch('complete');
      },
      (errorResponse: HttpErrorResponse) => {
        this.bulkSaving = false;
        var msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  initializePendingColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.PendingUsers;

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    if (this.id === 'pending-users') {
      this.buttons = [
        {
          name: 'Back',
          pagenavigation: 'pending-users'
        },
        {
          name: 'Update User',
          pagenavigation: 'add-users'
        }
      ];
    } else {
      this.buttons = [

        {
          name: 'Back',
          pagenavigation: 'manage-users'
        },
        {
          name: 'Update',
          pagenavigation: 'add-users'
        },
        {
          name: 'Delete',
          pagenavigation: 'delete'
        }
        // ,
        // {
        //   name: 'Assign Documents',
        //   pagenavigation: 'assign-document'
        // }
      ];
    }
  }
}